<template>
    <form ref="form" :rules="rules" :model="form" label-position="left" class="userform">
        <div class="card shadow mx-auto mt-4 pl-lg-5 pr-lg-5 ">
            <div class="card-body text-left">
                <div class="row">
                    <div class="col-md-12 float-left">
                        <div class="text-with-icon mt-3">
                            <svg-icon :name="this.brand + '/location'" width="18" height="auto"></svg-icon>
                            <p class="d-inline ml-2">Where are you travelling from?</p>
                        </div>
                        <div class="joined-inputs mt-4 mb-3">
                            <div class="joined-input-first d-flex align-items-center px-2 py-3"  @click="onFocus('origin')">
                                <span class="mb-0" aria-labelledby="origin-location-input">From</span>
                                <auto-complete id="origin-location-input" aria-labelledby="origin-location-input"  :disabled="false" placeholder="Start typing an address or postcode" inputClass="border-0 ml-2 w-100" v-model="form.origin"></auto-complete>
                            </div>
                            <div v-if="brand == 'raigmore'" class="joined-input-last d-flex align-items-center px-2 py-3 bg-light">
                                <span class="mb-0" aria-labelledby="destination-location-input">To</span>
                                <input disabled id="destination-location-input" type="text" aria-labelledby="destination-location-input" :placeholder="this.destinationPlaceholder" class="border-0 ml-2 w-100 bg-light placeholder-text"/>
                            </div>
                            <div v-else class="joined-input-last d-flex align-items-center px-2 py-2 bg-light" @click="onFocus('destination')">
                                <span class="mb-0" aria-labelledby="destination-location-input">To</span>
                                <destination-auto-complete id="destination-location-input" aria-labelledby="destination-location-input"  :disabled="false" placeholder="Start typing a site name" inputClass="border-0 ml-2 w-100" v-model="form.destination"></destination-auto-complete>
                            </div>
                        </div>
                        <span class="form-error" v-if="errors.origin"> {{ errors.origin }}</span>
                        <span class="form-error" v-if="errors.destination"> {{ errors.destination }}</span>
                        <div class="row" @click="onFocus('arrive_time')">
                            <div class="col-12">
                                <div class="text-with-icon pt-3 mt-3 border-top">
                                    <svg-icon aria-labelledby="calendar icon" :name="this.brand +'/calendar'" width="20" height="auto"></svg-icon>
                                    <p class="d-inline ml-2 mt-4">Appointment date</p>
                                        <b-input-group class="date-input mt-2">
                                            <b-form-input
                                                id="input"
                                                type="text"
                                                v-model="arriveDateModel"
                                                placeholder="No date selected"
                                                class=""
                                                readonly
                                                @click="openCalendar()"
                                                ></b-form-input>
                                                <b-input-group-append>
                                                    <b-form-datepicker
                                                        id="calendar-button"
                                                        label="Select appointment date"
                                                        placeholder="Select Date"
                                                        v-model="arriveDateModel"
                                                        class="appointment-date w-100 pl-3"
                                                        :min="minDate"
                                                        button-only
                                                        right
                                                        >
                                                    </b-form-datepicker>
                                                </b-input-group-append>
                                        </b-input-group>
                                </div>
                            </div>
                            <div class="col-12 ">
                                <div class="text-with-icon mt-3">
                                    <svg-icon aria-labelledby="clock icon" :name="this.brand + '/clock'" width="20" height="auto"></svg-icon>
                                    <p class="d-inline ml-2 mt-4">Appointment time</p>
                                    <div class="row">
                                        <div class="hour-min-select hour-select col-lg-6 col-sm-6 float-left pr-3">
                                            <vue-select
                                                label="select appointment time hour"
                                                required
                                                v-model="arriveTimeHourModel"
                                                class="mt-2"
                                                :options="options.hours">
                                            </vue-select>
                                        </div>
                                        <div class="hour-min-select min-select col-lg-6 col-sm-6 pl-lg-3 float-right">
                                            <vue-select
                                                label="select appointment time minutes"
                                                required
                                                :placeholder="arriveTimeMinsModel"
                                                v-model="arriveTimeMinsModel"
                                                class="mt-2"
                                                :options="options.minutes">
                                            </vue-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-12">
                                <div class="text-with-icon mt-3 pb-4 border-bottom">
                                    <svg-icon aria-labelledby="clock icon" :name="this.brand + '/clock'" width="20" height="auto"></svg-icon>
                                        <p class="d-inline ml-2 mt-4">Estimated appointment length</p>
                                        <vue-select class="bg-white mt-2 appointment-length"
                                            :options="appointment.hours"
                                            v-model="selectedTime"
                                            :placeholder="this.selectedTime.label"
                                            >
                                        </vue-select>
                                    </div>
                                </div>
                            </div>
                            <span class="form-error" v-if="errors.arrive_time">{{ errors.arrive_time }}</span>
                        </div>
                            <!-- section for terms and conditions and see journey options moved for raigmore design to be on right hand side-->
                            <div v-if="this.brand === 'raigmore'">
                                <TransportAccessSelection  :form="this.form"></TransportAccessSelection>
                                <div class="col-lg-12 mb-2 mt-3">
                                    <div class="form-check">
                                        <input class="form-check-input scale-1-5"  v-model="acceptTermsCheckbox"  type="checkbox" value id="acceptTermsCheck" @change="onCheckboxChange" />
                                        <label class="form-check-label ml-2" for="acceptTermsCheck">
                                            <strong>I have read and accepted the <router-link target="_blank" :to="{name: 'Terms'}">Terms and Conditions </router-link> and <router-link target="_blank" :to="{name: 'Privacy'}">Privacy Policy</router-link></strong>
                                        </label>
                                    </div>
                                    <span class="form-error" v-if="acceptTermsCheckboxError">Please accept the Terms and Conditions</span>
                                </div>
                                <div class="text-center">
                                    <button type="button" id="submit-button" class="btn btn-primary col-11 ml-4 mr-4 px-4 py-3 mt-3 rounded-pill d-flex align-items-center justify-content-center w-100" @click="search">
                                        <h2 class="d-inline mb-0">See my journey options</h2>
                                        <svg-icon aria-labelledby="submit-button" class="ml-3" :name="this.brand +'/arrow-right'" width="24" height="auto"></svg-icon>
                                    </button>
                                </div>
                            </div>
                            <!-- end of raigmore specific section-->
                    </div>
                         <TransportAccessSelection  :form="this.form"></TransportAccessSelection>
                    <div class="text-center border-top">
                        <button type="button" class="btn btn-primary col-11 ml-4 mr-4 px-4 py-3 mt-4 rounded-pill d-flex align-items-center justify-content-center w-100" @click="search">
                            <h2 class="d-inline mb-0">See my journey options</h2>
                            <svg-icon aria-labelledby="arrow right icon" class="ml-3" :name="this.brand +'/arrow-right'" width="24" height="auto"></svg-icon>
                        </button>
                    </div>
                     <div class="row" v-if="this.brand === 'nhs'">
                        <div class="col-11 mb-2 mt-3 text-center">
                            <strong>By clicking "See my journey options" you are agreeing to <router-link target="_blank" :to="{name: 'Terms'}">Terms and Conditions</router-link> and <router-link target="_blank" :to="{name: 'Privacy'}">Privacy Policy</router-link> of GoNHS Tayside</strong>
                        </div>
                    </div>
                </div>
            </div>
    </form>
</template>
<script>
import mutationsMapping from '@/store/mutations-mapping'
import {
    mapState,
    mapMutations,
    mapActions,
} from 'vuex'
import moment from 'moment'
import AutoComplete from '@/components/AutoComplete.vue'
import DestinationAutoComplete from '@/components/DestinationAutoComplete.vue'
import {
    VBModal,
    BFormDatepicker,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
} from 'bootstrap-vue'
import TransportAccessSelection from '@/components/TransportAccessSelection.vue'
import _ from 'lodash'

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {

    name: 'Home',
    components: {
        AutoComplete,
        TransportAccessSelection,
        DestinationAutoComplete,
        BFormDatepicker,
        BFormInput,
        BInputGroup,
        BInputGroupAppend,
    },
    directives: {
        'b-modal': VBModal,
    },
    data() {
        const validatearriveDateModel = (rule, value, callback) => {
            if (value === '' && this.arriveDateModel) {
                callback(new Error('Please select origin of the user'))
            } else {
                callback()
            }
        }
        return {
            minDate: moment().format('YYYY-MM-DD'),
            brand: whitelabel.brand,
            destinationPlaceholder: whitelabel.destination,
            form: {
                origin: '',
                destination: '',
                arrive_time: '',
                return_time: '',
                has_car_access: false,
                has_concessionary_pass: false,
                has_railcard: false,
                railcard: '',
                arrive_by_buffer: '20',
            },
            rules: {
                arriveDateModel: [{ validator: validatearriveDateModel, required: false }],
            },
            placeholder: 'Start typing an address or postcode',
            arriveTimeMinsModel: '',
            arriveTimeHourModel: '',
            arriveTimeModel: '',
            arriveDateModel: '',
            railcardOptions: {
                // 'network-railcard': 'Network Railcard',
                '16-17': '16-17 Saver',
                '16-25': '16-25 Railcard',
                '26-30': '26-30 Railcard',
                'disabled-person': 'Disabled Persons Railcard',
                senior: 'Senior Railcard',
            },
            options: {
                hours: [
                ],
                minutes: [

                ],
            },
            appointment: {
                hours: [
                    { label: '30 minutes', value: 30 },
                    { label: '1 hour', value: 60 },
                    { label: '1 hour 30 minutes', value: 90 },
                    { label: '2 hours', value: 120 },
                    { label: '2 hours 30 minutes', value: 150 },
                    { label: '3 hours', value: 180 },
                ],
            },
            selectedTime: {},
            modalShow: false,
            acceptTermsCheckbox: false,
            acceptTermsCheckboxError: false,
            inputFocused: false,
        }
    },
    computed: {
        arriveDateAndTime() {
            if (this.arriveDateModel) {
                return `${moment(this.arriveDateModel).format('YYYY/MM/DD')} ${this.arriveTimeModel}:00`
            }
            return null
        },
        ...mapState([
            'origin',
            'destination',
            'arriveDate',
            'arriveTime',
            'arriveTimeHour',
            'arriveTimeMins',
            'returnDate',
            'journeyType',
            'via',
            'errors',
            'destinationRaigmore',
            'planner',
        ]),
        plusOneHour() {
            return moment(this.form.arrive_time).add(1, 'hours').format('YYYY/MM/DD HH:mm:ss');
        },
        plusAppointment() {
            return moment(this.form.arrive_time).add(this.selectedTime.value, 'minutes').format('YYYY/MM/DD HH:mm:ss');
        },
    },
    mounted() {
        console.log(this.min)
        this.form.origin = this.origin
        this.arriveDateModel = this.arriveDate
        this.arriveTimeModel = this.arriveTime
        this.arriveTimeHourModel = this.arriveTimeHour
        this.arriveTimeMinsModel = this.arriveTimeMins
        this.form.arrive_time = this.arriveDate
        this.form.has_concessionary_pass = this.hasConcessionaryPass
        this.form.has_car_access = this.hasAccessToCar
        this.form.railcard = this.railcardType
        this.options.hours = _.range(8, 24).map((i) => _.padStart(i, 2, '0'))
        this.options.minutes = _.range(0, 60, 5).map((i) => _.padStart(i, 2, '0'))
        if (this.brand === 'raigmore') {
            this.form.destination = this.destinationRaigmore
        }
        this.selectedTime = { label: '1 hour', value: 60 }
    },
    methods: {
        ...mapMutations(mutationsMapping),
        ...mapActions([
            'searchQuery',
        ]),
        toggleHasRailCard() {
            this.form.has_railcard = !this.form.has_railcard
            if (this.form.has_railcard) {
                this.$refs['railcard-modal'].show()
            } else {
                this.form.railcard = ''
                this.form.has_railcard = false
            }
        },
        changeRailcard() {
            this.$refs['railcard-modal'].show()
        },
        hideModal() {
            this.$refs['railcard-modal'].hide()
        },
        selectRailcardType(index) {
            this.form.railcard = this.railcardOptions[index]
            this.$refs['railcard-modal'].hide()
        },
        search() {
            if (this.validate()) {
                this.clearResults()

                this.arriveTimeModel = `${this.arriveTimeHourModel}:${this.arriveTimeMinsModel}` // could be a computed prop
                this.form.arrive_time = this.arriveDateAndTime

                this.updateOrigin(this.form.origin)
                this.updateDestination(this.form.destination)
                this.updateArriveTimeHour(this.arriveTimeHourModel)
                this.updateArriveTimeMinutes(this.arriveTimeMinsModel)
                this.updateArriveDate(this.arriveDateModel)
                this.updateArriveTime(this.arriveTimeModel)
                this.updateArriveDateAndTime(this.arriveDateAndTime)

                this.form.return_time = this.plusAppointment

                if (this.form.railcard === '') {
                    this.form.railcard = null
                }

                this.updateRailcardType(this.form.railcard)
                this.updateHasAccessToCar(this.form.has_car_access)
                this.updateHasConcessionaryPass(this.form.has_concessionary_pass)

                if (this.planner.currentDestination) {
                    this.form.planner_destination_id = this.planner.currentDestination.id
                }

                this.searchQuery({
                    params: this.form,
                    router: this.$router,
                })
            }
        },
        onFocus(field) {
            this.setError({
                field,
                error: false,
            })
        },
        onCheckboxChange() {
            this.acceptTermsCheckboxError = false
        },
        onModalClose() {
            if (!this.form.railcard) {
                this.form.has_railcard = false
            }
        },
        validate() {
            let validate = true
            if (!this.form.origin) {
                validate = false
                this.setError({
                    field: 'origin',
                    error: 'The origin field is required.',
                })
            }
            if (!this.form.destination) {
                validate = false
                this.setError({
                    field: 'destination',
                    error: 'The destination field is required.',
                })
            }
            if (!this.arriveDateModel) {
                validate = false
                this.setError({
                    field: 'arrive_time',
                    error: 'The arrive time is not a valid date.',
                })
            }
            return validate
        },
        openCalendar() {
            const el = document.getElementById('calendar-button')
            el.click();
        },
    },
}
</script>
<style lang="scss" scoped>

.appointment-length .vs__actions{
    width: 40px;
}

.input-group{
    align-items: center;
}

::v-deep .btn-secondary {
    background-color: #E2E2F5;
    border-color: #E2E2F5;
    color:#4547BF;
    padding: 0.5rem 1rem;
}

::v-deep .btn-secondary:hover{
    background-color: #E2E2F5;
    border-color: #E2E2F5;
    color:#4547BF;
    .b-icon {
        fill: #4547BF;
    }
}

::v-deep .btn-secondary:not(:disabled):not(.disabled):active{
    background-color: #E2E2F5;
    border-color: #E2E2F5;
    color:#4547BF;
}

::v-deep .btn-secondary:focus{
    background-color: #E2E2F5;
    border-color: #E2E2F5;
    color:#4547BF;
}

::v-deep .show > .btn-secondary.dropdown-toggle{
    background-color: #E2E2F5;
    border-color: #E2E2F5;
    color:#4547BF;
}

::v-deep .b-icon{
    fill: #4547BF;
    margin-bottom: 3px;
}

::v-deep .dropdown-toggle::after {
    display:none;
}

.input-group > .form-control:not(:last-child), .input-group > .custom-select:not(:last-child) {
    border-radius: none;
    background-color:white;
    border: 1px solid  black;
    border-radius: 6px 6px 6px 6px;
    height:43px
}

</style>
